// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"580":"8e07b8f5","755":"423cceda","797":"194db70c","949":"7474d4cb"}[chunkId] + ".css";
};